import Vue from 'vue'
import RecommendedProducts from './RecommendedProducts.vue'
import vueCustomElement from 'vue-custom-element'

Vue.use(vueCustomElement);

Vue.customElement('recommended-products-app', RecommendedProducts, { shadow: false })
